import React, {Component} from "react";
import http from "@/http"
import DefaultStatus from "../../overview/device/deviceInfo/components/DefaultStatus";

class AlarmDevice extends Component {
    state = {
        detail: {}
    }

    componentDidMount() {
        const {deviceId} = this.props
        this.getDeviceDetail(deviceId)
    }

    getDeviceDetail = (id) => {
        http.tokiot.device.get({id})
            .then(ret => {
                ret && this.setState({detail: ret})
            })
    }

    render() {
        const {deviceId,children} = this.props
        const {detail} = this.state

        return <div className='realtime-alarm-modal-body-left'>
            {children}
            <DefaultStatus key={deviceId} detail={detail} detailAll={detail} isVideo={false}/>
        </div>
    }
}

export default AlarmDevice;